import React from 'react';
import MetaTags from '~/components/MetaTags';
import NAMES from '~/constants/NAMES';
const Meta: React.FC = (): React.ReactElement => <MetaTags title={NAMES.APP} data-sentry-element="MetaTags" data-sentry-component="Meta" data-sentry-source-file="meta.tsx" />;
export default Meta;